module.exports = __webpack_public_path__ + "static/media/img-scope1.c045630e.png";